// extracted by mini-css-extract-plugin
export default {"catalogRoot":"CatalogChrome_catalogRoot__ev10c"};